<script setup>
import { getLocalizedUrl } from '@js/App/Plugins/LocalizedUrls'

defineProps({
  size: {
    type: String,
    default: 'md'
  },
  href: {
    type: [String, Boolean],
    default: () => getLocalizedUrl('rentbird-plus')
  }
})

</script>
<template>
  <!-- Plain <a>, never an Inertia Link: /plus is served by the marketing Worker, not
       Laravel, so an Inertia visit gets non-Inertia HTML back and shows it in the error modal. -->
  <component
    :is="href ? 'a' : 'div'"
    :href="href"
    class="block"
  >
    <img
      src="../../../../assets/images/rentbird-plus-logo.svg"
      :class="{
        'min-w-[130px] w-[130px]': size === 'md',
        'min-w-[110px] w-[110px]': size === 'sm',
        'min-w-[98px] w-[98px]': size === 'xs'
      }"
    >
  </component>
</template>
